import { useTranslation } from 'react-i18next';

function OfflineBanner() {
  const { t } = useTranslation();
  return <div className="driver-offline-banner">{t('offline.banner')}</div>;
}

export default OfflineBanner;
